import { Link } from "react-router-dom";
import ProductCard from "../components/ProductCard";
import "./Home.css";

const Home = ({ addToCart, products = [], loading = true }) => {
  const featuredProducts = products.slice(0, 3);

  if (loading) {
    return (
      <div className="home">
        <div className="loading-spinner">
          <p>Caricamento prodotti...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="home">
      <section className="hero-banner">
        <div className="hero-content">
          <h1>Benvenuto su BioPallet</h1>
          <p>I migliori pallet per il tuo business, a prezzi competitivi</p>
          <Link to="/products" className="cta-button">
            Scopri i Nostri Prodotti →
          </Link>
        </div>
      </section>

      <section className="promo-section">
        <div className="promo-card">
          <h3>📦 Spedizione Veloce</h3>
          <p>Consegna in 24-48 ore su ordini sopra €100</p>
        </div>
        <div className="promo-card">
          <h3>💳 Pagamenti Sicuri</h3>
          <p>Tutte le principali carte di credito accettate</p>
        </div>
        <div className="promo-card">
          <h3>🛡️ Garanzia Qualità</h3>
          <p>Tutti i pallet garantiti e controllati prima della spedizione</p>
        </div>
      </section>

      <section className="featured-section">
        <h2>I Nostri Bestseller</h2>
        {products.length > 0 ? (
          <div className="products-grid">
            {featuredProducts.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                onAddToCart={addToCart}
              />
            ))}
          </div>
        ) : (
          <p className="no-products">Nessun prodotto disponibile</p>
        )}
      </section>

      <section className="why-us-section">
        <h2>Perché Scegliere BioPallet?</h2>
        <div className="reasons-grid">
          <div className="reason-card">
            <span className="reason-icon">✓</span>
            <h4>Ampia Selezione</h4>
            <p>Centinaia di prodotti sempre disponibili</p>
          </div>
          <div className="reason-card">
            <span className="reason-icon">✓</span>
            <h4>Prezzi Competitivi</h4>
            <p>I migliori prezzi del mercato garantiti</p>
          </div>
          <div className="reason-card">
            <span className="reason-icon">✓</span>
            <h4>Supporto Professionale</h4>
            <p>Team esperto pronto ad aiutarti</p>
          </div>
          <div className="reason-card">
            <span className="reason-icon">✓</span>
            <h4>Consegna Affidabile</h4>
            <p>Partner logistici di fiducia</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
